import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./Header.scss";
import logo from "../../assets/logo-black.svg";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const history = useHistory();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleCatalogueClick = () => {
    history.push("/catalogue");
    closeMenu();
  };

  return (
    <nav className="header">
      <div className="header__container">
        {/* Logo */}
        <a href="/" className="header__logo">
          <img src={logo} alt="Stucchi Logo" />
        </a>

        {/* Menu principale desktop */}
        <ul className="header__menu">
          <li className="header__item">
            <a
              href="https://www.stucchigroup.com/innesti-rapidi/"
              className="header__link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Couplings
            </a>
          </li>
          <li className="header__item">
            <a
              href="https://www.stucchigroup.com/innesti-rapidi/?famiglia[]=multinnesti"
              className="header__link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Multicouplings
            </a>
          </li>
          <li className="header__item">
            <a
              href="https://www.stucchigroup.com/innesti-rapidi/?famiglia[]=monoblocco"
              className="header__link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Castings
            </a>
          </li>
          <li className="header__item">
            <a
              href="https://www.stucchigroup.com/innesti-rapidi/?famiglia[]=serie-speciali"
              className="header__link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Special Series
            </a>
          </li>
          <li className="header__item">
            <a
              href="https://www.stucchigroup.com/innesti-rapidi/?famiglia[]=prodotti-complementari"
              className="header__link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Complementary Products
            </a>
          </li>
          <li className="header__item">
            <a
              href="https://www.stucchigroup.com/support-tools/"
              className="header__link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Support Tools
            </a>
          </li>
        </ul>

        {/* Sezione destra con icone e hamburger */}
        <div className="header__actions">
          {/* Icona Ricerca */}
          <a
            href="https://www.stucchigroup.com/innesti-rapidi/"
            className="header__icon-btn"
            aria-label="Cerca"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            </svg>
          </a>

          {/* Icona Mondo */}
          <a
            href="https://www.stucchigroup.com/stucchi-nel-mondo/"
            className="header__icon-btn"
            aria-label="Lingua"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z" />
            </svg>
          </a>

          {/* Icona Mail */}
          <a
            href="https://www.stucchigroup.com/contatti/"
            className="header__icon-btn"
            aria-label="Contatti"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
            </svg>
          </a>

          {/* Hamburger Button */}
          <button
            className={`header__hamburger ${isMenuOpen ? "active" : ""}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      {/* Menu Mobile */}
      <div className={`header__mobile-menu ${isMenuOpen ? "active" : ""}`}>
        <ul className="header__mobile-list">
          <li className="header__mobile-item">
            <a
              href="https://www.stucchigroup.com/innesti-rapidi/"
              className="header__mobile-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              Couplings
            </a>
          </li>
          <li className="header__mobile-item">
            <a
              href="https://www.stucchigroup.com/innesti-rapidi/?famiglia[]=multinnesti"
              className="header__mobile-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              Multicouplings
            </a>
          </li>
          <li className="header__mobile-item">
            <a
              href="https://www.stucchigroup.com/innesti-rapidi/?famiglia[]=monoblocco"
              className="header__mobile-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              Castings
            </a>
          </li>
          <li className="header__mobile-item">
            <a
              href="https://www.stucchigroup.com/innesti-rapidi/?famiglia[]=serie-speciali"
              className="header__mobile-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              Special Series
            </a>
          </li>
          <li className="header__mobile-item">
            <a
              href="https://www.stucchigroup.com/innesti-rapidi/?famiglia[]=prodotti-complementari"
              className="header__mobile-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              Complementary Products
            </a>
          </li>
          <li className="header__mobile-item">
            <a
              href="https://www.stucchigroup.com/support-tools/"
              className="header__mobile-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              Support Tools
            </a>
          </li>
          <li className="header__mobile-item">
            <button
              className="header__mobile-link header__mobile-link--button"
              onClick={handleCatalogueClick}
            >
              View Catalog
            </button>
          </li>
        </ul>
      </div>

      {/* Overlay */}
      {isMenuOpen && (
        <div className="header__overlay" onClick={closeMenu}></div>
      )}
    </nav>
  );
};

export default Header;
